import { DateOrders, OrderData } from '~/shared/api/services/warehouses/types'

export const adaptiveFontSize = (text: string) => {
  if (text.length > 16) return 'text-[12px]'
  if (text.length > 10) return 'text-[14px]'
  return 'text-[16px]'
}

export const getExpressOrders = (dates: DateOrders[]) => {
  return dates.reduce(
    (acc, current) => [
      ...acc,
      ...current.orders.filter((order) => order.express),
    ],
    [] as OrderData[],
  )
}

export const getRegularOzonOrders = (dates: DateOrders[]) => {
  return dates
    .map(({ date, orders }) => ({
      date,
      orders: orders.filter((order) => !order.express),
    }))
    .filter(({ orders }) => orders.length > 0)
}
